<template>
  <div class="bkbm">
    <Header title="补考报名" type="0" route="/new/Home"></Header>
    <van-tabs class="bkbm-top" v-model="active" @change="tabFuct">
      <van-tab title="报名" name="bm" />
      <van-tab title="已报课程" name="ybkc" />
    </van-tabs>
    <div v-if="active === 'bm'" class="bmkc">
      <div class="xnxq" @click="xnxqFuct">
        <span>{{xnxqName}}</span>
        <img src="@/assets/images/aroow.png" alt="">
      </div>
      <NOdata title="暂无记录~" v-if="kbmList.length === 0"></NOdata>
      <div v-else>
        <div class="bm-list" v-for="(i,y) in kbmList" :key="y">
          <div class="list-text">
            <div class="text-one">
              <span>{{i.kcmc}}-{{i.kch}}</span>
              <p>开课学期：{{i.kkxq}}</p>
              <p>考试性质：{{i.ksxzmc}}</p>
            </div>
            <div class="text-two">
              <b>{{i.zcj}}</b>
              <p>总成绩</p>
            </div>
          </div>
          <div class="button-foot" v-if="sfbm==='1'">
            <van-button class="foot-bm" type="default" @click="bmFuct(i)">报名</van-button>
          </div>
        </div>
      </div>
    </div>
    <div v-else class="bmkc">
      <div class="xnxq" @click="xnxqFuct">
        <span>{{xnxqName}}</span>
        <img src="@/assets/images/aroow.png" alt="">
      </div>
      <NOdata title="暂无记录~" v-if="ybmList.length == 0"></NOdata>
      <div v-else>
        <div class="bm-list" v-for="(item,index) in ybmList" :key="index">
          <div class="list-text">
            <div class="text-one">
              <span>{{item.kcmc}}-{{item.kch}}</span>
              <p>开课学期：{{item.kkxq}}</p>
              <p>考试性质：{{item.ksxzmc}}</p>
            </div>
            <div class="text-two">
              <b>{{item.zcj}}</b>
              <p>总成绩</p>
            </div>
          </div>
          <div class="button-foot" v-if="item.canqx === '1'">
            <van-button class="foot" type="default" @click="qxbmFuct(item)">取消报名</van-button>
          </div>
        </div>
      </div>
    </div>
    <van-popup class="qzPicker" v-model="showXnxq" round position="bottom">
      <van-picker
        show-toolbar
        title="学年学期"
        :columns="columns"
        @cancel="showXnxq = false"
        @confirm="onXnxqConfirm"
      />
    </van-popup>
  </div>
</template>
<script>
import { Dialog } from "vant";
import { Api } from "@/utils/axios";
export default{
  data(){
    return{
      active:'bm',
      showXnxq:false,
      xnxqName:'',
      xnxqVal:'',
      columns:[],
      kbmList:[],
      ybmList:[],
      sfbm:'1'
    }
  },
  created() {
    this.getData()
  },
  methods:{
    tabFuct(){
      this.getSearchData(this.xnxqVal)
      // this.getData()
    },
    async getData(){
      const res = await Api.getXnxq()
      this.columns = res.xnxq01List.map(i=>{
        if(i.sfdqxq === 1){
          this.xnxqVal = i.xnxq01id
          this.xnxqName = i.xqmc
          this.getSearchData(i.xnxq01id)
        }
        return {
          text:i.xqmc,
          value:i.xnxq01id
        }
      })
    },
    async getSearchData(val){
      const res = await Api.getBkbmList({xnxq01id:val})
      this.sfbm = res.sfbm
      this.kbmList = res.kbmList
      this.ybmList = res.ybmList
    },
    xnxqFuct(){
      this.showXnxq = true
    },
    onXnxqConfirm(val){
      this.xnxqName = val.text
      this.xnxqVal = val.value
      this.showXnxq = false
      this.getSearchData(val.value)
    },
    bmFuct(data){
      Dialog.confirm({
            message: "是否报名补考此课程?"
        }).then(() => {
          Api.getBkbmSave({cj0716id:data.cj0716id}).then(res=>{
            this.$toast(res.Msg);
            this.active = 'bm'
            this.getSearchData(this.xnxqVal)
          })
        }).catch(() => {});
    },
    qxbmFuct(data){
      Dialog.confirm({
            message: "是否取消报名此课程?"
        }).then(() => {
          Api.getBkbmCancel({cj0716id:data.cj0716id}).then(res=>{
            this.$toast(res.Msg);
            this.active = 'ybkc'
            this.getSearchData(this.xnxqVal)
          })
        }).catch(() => {});
    },
  }
}
</script>
<style lang="less" scoped>
.bkbm{
  width: 100%;
  height: calc(100vh - 50px);
  overflow-y:scroll;
  background: #f0f0f2;
}
.bkbm-top{
  width: 100%;
  position: fixed;
  top:50px;
  left: 0;
}
.bkbm-top /deep/.van-tab__text{
  color:#999;
}
.bkbm-top /deep/.van-tab--active .van-tab__text{
  color:#333;
  font-weight: inherit;
}
.bkbm-top /deep/.van-tabs__line{
  background-color: #7469F8;
}
.bmkc{
  padding: 56px 12px 12px;
  box-sizing: border-box;
  .xnxq{
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding:0.56rem 0.63rem;
    box-sizing: border-box;
    border-radius: 8px;
    background: #fff;
    span{
      color:#333;
      font-size: 0.9rem;
    }
  }
}
.bm-list{
  width: 100%;
  background: #fff;
  border-radius: 0.5rem;
  margin-top:0.63rem;
  .list-text{
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding:0.88rem 0.94rem 0.63rem 0.94rem;
    box-sizing: border-box;
    .text-one{
      span{
        color:#333;
        font-weight: 600;
        font-size: 1rem;
        line-height: 1;
        display: block;
        margin-bottom:0.6rem;
      }
      p{
        color: #666;
        font-size: 0.75rem;
        line-height: 1;
        margin-bottom:0.4rem;
      }
    }
    .text-two{
      text-align: center;
      position: relative;
      padding-right:0.6rem;
      box-sizing: border-box;
      b{
        font-size: 1.25rem;
        font-weight: 500;
        line-height: 1.75rem;
        color:#7469f8;
      }
      p{
        font-size: 0.75rem;
        line-height: 1;
        color:#7469f8;
      }
    }
    .text-two::before{
      content: "";
      width: 1px;
      height: 100%;
      background: #e5e5e5;
      position: absolute;
      top:0;
      left:-2.16rem;
    }
  }
  .button-foot{
    padding:0.63rem 0.94rem;
    box-sizing: border-box;
    border-radius: 0 0 0.5rem 0.5rem;
    background: rgba(116,105,248,0.04);
    display: flex;
    justify-content: flex-end;
    .foot{
      width: 6rem;
      height: 2rem;
      background: #7469F8;
      color:#fff;
    }
    .foot-bm{
      width: 5rem;
      height: 2rem;
      background: #7469F8;
      color:#fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/newPages/student/bkbm/index.vue